<template>
    <div style="width: '100%'; background-color: #191a1c"></div>
</template>
<script>
import go, { Margin } from 'gojs'

let $ = go.GraphObject.make

export default {
  props: ['currentNode', 'timelineId', 'modelData'],  // accept model data as a parameter
  data () {
    return {
      diagram: null,
      nodeColors: {
        'Scene': '#f634a5',
        'User': '#bf975f',
        'Logic': '#8debd2',
        'Chatbot': '#643dff',
        'Universal': '#fff'
      },
      nodeShapes: {
        'Scene': 'M20.9,6.1A13.6,13.6,0,1,1,7.3,19.7,13.6,13.6,0,0,1,20.9,6.1ZM54.1,0A16.6,16.6,0,1,1,37.5,16.6,16.6,16.6,0,0,1,54.1,0ZM88.4,45.1,75.6,52.4V43.7a7.1,7.1,0,0,0-7.1-7.1H7.1A7.1,7.1,0,0,0,0,43.7v42a7.1,7.1,0,0,0,7.1,7.1H68.5a7.1,7.1,0,0,0,7.1-7.1V77l12.7,7.3a4.4,4.4,0,0,0,6.6-3.8V48.9A4.3,4.3,0,0,0,88.4,45.1ZM48.3,66.8,32.5,76.1A2.5,2.5,0,0,1,28.7,74V55.4a2.5,2.5,0,0,1,3.8-2.1l15.8,9.3A2.4,2.4,0,0,1,48.3,66.8Z',
        'User': 'M20.5,7.1c0,3.4-2.8,8.9-6.2,8.9S8.1,10.5,8.1,7.1,9,0,14.3,0,20.5,3.7,20.5,7.1Zm2.4,10.7H21.1a3.4,3.4,0,0,1-3-1.8,5.9,5.9,0,0,1-4,1.8A6.1,6.1,0,0,1,10,16a3.4,3.4,0,0,1-3,1.8H5.3s-3.2.9-5.3,5.4v3.6a1.8,1.8,0,0,0,1.8,1.8H26.4a1.8,1.8,0,0,0,1.7-1.8V23.2C26,18.7,22.9,17.8,22.9,17.8Z',
        'Logic': 'M32.5,17a5.1,5.1,0,0,0,5,5c2.4,0,3.6-1.6,4.4-.6s.5,1.1.5,2.9V34h8.3c1.2,0,1.3-.1,1.4-.3s-.2-1.3-.2-3.1c0-3.8,4-6.8,7.5-6.8s7.5,2.9,7.5,6.8c0,1.8-.4,2.6-.2,3.1s.3.3,1.5.3h8.2V4s.2-2.1-.9-3.1S72.1,0,72.1,0H42.4V9.7c0,1.9,0,2.5-.5,3s-1.9-.6-4.4-.6A5,5,0,0,0,32.5,17ZM0,34H9.7c1.9,0,2.5.1,3,.5s-.6,2-.6,4.5A4.9,4.9,0,0,0,17,43.9,5,5,0,0,0,22,39c0-2.5-1.6-3.7-.6-4.5s1.1-.5,2.9-.5H34V25.8c0-1.2-.1-1.4-.3-1.5s-1.3.2-3.1.2c-3.8,0-6.8-4-6.8-7.5s2.9-7.5,6.8-7.5c1.8,0,2.6.4,3.1.2s.3-.2.3-1.4V0H4.8S2-.2.9.9,0,4.4,0,4.4V34ZM43.9,59.6A4.9,4.9,0,0,0,39,54.7c-2.5,0-3.7,1.6-4.5.6s-.5-1.1-.5-3V42.6H25.8c-1.2,0-1.4.2-1.5.4s.2,1.3.2,3c0,3.8-4,6.9-7.5,6.9S9.5,50,9.5,46c0-1.7.4-2.5.2-3s-.2-.4-1.4-.4H0V72s0,2.4,1,3.5,3.5,1.2,3.5,1.2H34V67c0-1.9.1-2.5.5-3s2,.6,4.5.6A4.9,4.9,0,0,0,43.9,59.6ZM77.6,89.1,98.5,68.3l-6.9-6.8c-1.3-1.4-1.7-1.9-1.7-2.5s1.8-1,3.5-2.7a4.8,4.8,0,0,0,0-7,4.9,4.9,0,0,0-6.9,0C84.7,51,85,53,83.7,52.9s-1.1-.5-2.4-1.8l-6.9-6.9-5.8,5.9c-.8.8-.9,1-.8,1.3s1.1.7,2.3,2c2.7,2.7,2,7.6-.5,10.1s-7.3,3.3-10.1.5c-1.3-1.3-1.5-2.1-2-2.3s-.4-.1-1.3.8l-5.8,5.8L71.3,89.2s1.6,1.9,3.1,1.9S77.6,89.1,77.6,89.1Z',
        'Chatbot': 'M58,16H56V11.7A6.1,6.1,0,0,0,59.7,4,6,6,0,1,0,48.3,8,6.2,6.2,0,0,0,52,11.7V16H28V11.7A6.1,6.1,0,0,0,31.7,4,6,6,0,0,0,20.3,8,6.2,6.2,0,0,0,24,11.7V16H22A10,10,0,0,0,12,26V58A10,10,0,0,0,22,68h6V78a2,2,0,0,0,2,2,1.7,1.7,0,0,0,1.2-.4L46.7,68H58A10,10,0,0,0,68,58V26A10,10,0,0,0,58,16ZM54.9,51.8a35.3,35.3,0,0,1-29.8,0,2,2,0,1,1,1.8-3.6c7.5,3.8,18.7,3.8,26.2,0a2,2,0,0,1,1.8,3.6ZM33.8,38.2H29.1V29.6h4.7Zm16,0H45.1V29.6h4.7ZM0,38v8a6,6,0,0,0,6,6H8V32H6A6,6,0,0,0,0,38Zm74-6H72V52h2a6,6,0,0,0,6-6V38A6,6,0,0,0,74,32Z',
        'Universal': 'M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z'
      },
      buttonTextStyle: {
        font: 'regular 8pt brother-1816, sans-serif', // button style
        stroke: 'black'
      }
    }
  },  // provide access to the GoJS Diagram
  mounted () {
    let myDiagram =
      $(go.Diagram, this.$el,
        {
          initialContentAlignment: go.Spot.Center,
          initialAutoScale: go.Diagram.None,
          layout: $(go.TreeLayout, { angle: 0, arrangement: go.TreeLayout.ArrangementHorizontal }),
          scale: 0.6,
          'undoManager.isEnabled': true, // this enables undo
          'linkingTool.isEnabled': false,  // invoked explicitly by drawLink function, below
          'linkingTool.direction': go.LinkingTool.ForwardsOnly,  // only draw "from" towards "to"
          // 'draggingTool.dragsTree': true,
          'ModelChanged': (e) => { this.$emit('model-changed', e) },
          'ChangedSelection': (e) => { this.$emit('changed-selection', e) },
          'SelectionDeleted': (e) => { this.$emit('selection-deleted', e) },
          'SelectionDeleting': (e) => { this.$emit('selection-deleting', e) },
          'ClipboardPasted': (e) => { this.$emit('paste-selection', e) }
        })
      // Whenever the Diagram.position or Diagram.scale change,
      // update the position of all simple Parts that have a _viewPosition property.
    myDiagram.addDiagramListener('ViewportBoundsChanged', (e) => {
      let dia = e.diagram
      dia.startTransaction('fix Parts')
      // only iterates through simple Parts in the diagram, not Nodes or Links
      dia.parts.each((part) => {
        // and only on those that have the "_viewPosition" property set to a Point
        if (part._viewPosition) {
          part.position = dia.transformViewToDoc(part._viewPosition)
          part.scale = 1 / dia.scale
        }
      })
      dia.commitTransaction('fix Parts')
    })
    myDiagram.add(
      $(go.Part,
        {
          layerName: 'Grid',
          _viewPosition: new go.Point(0, 0)
        },
      $(go.TextBlock, 'Root Tree', { font: 'bold 24pt sans-serif', stroke: 'white' })))
    /* **************** MENU ON RIGHT CLICK **************** */
    let nodeMenu =
      $(go.Adornment, 'Vertical',
        // $('ContextMenuButton',
          // $(go.TextBlock, 'Duplicate', buttonTextStyle()),
          // { click: addNodeAndLink }),
        // $('ContextMenuButton',
        //   $(go.TextBlock, 'Edit Timeline', this.buttonTextStyle),
        //   { click: (e, obj) => { this.$router.push({name: 'editTimeline', params: {timelineId: this.timelineId}, query: {timelineId: obj.part.data.timelineId, storyId: this.$route.query.id}}) } }),
        // $('ContextMenuButton',
        //   $(go.TextBlock, 'Edit', this.buttonTextStyle),
        //   { click: (e, obj) => { this.$store.dispatch('changeTreeDialog', {dialog: true}) } }),
        $('ContextMenuButton',
          $(go.TextBlock, 'Delete', this.buttonTextStyle),
          { click: (e, obj) => {
            e.diagram.commandHandler.deleteSelection()
            this.updateModel(this.modelData)
          }
          }
        ),
        $('ContextMenuButton',
          $(go.TextBlock, 'Collapse/Expand', this.buttonTextStyle),
          { click: this.collapseExpand })
      )

    /* scene node bg color */
    /* **************** SCENE **************** */
    const nodeTemplate =
        $(go.Node, 'Table',
          {
            mouseEnter: this.mouseEnter,
            mouseLeave: this.mouseLeave,
            contextMenu: nodeMenu,
            // resizeObjectName: 'SHAPE',
            selectionObjectName: 'SHAPE',
            // resizable: true,
            linkConnected: function (node, link, port) {
              if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks()
              if (link.toNode !== null) link.toNode.invalidateConnectedLinks()
            },
            linkDisconnected: function (node, link, port) {
              if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks()
              if (link.toNode !== null) link.toNode.invalidateConnectedLinks()
            },
            locationSpot: go.Spot.Center
          },
          new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
          $(go.Shape, 'RoundedRectangle',
            new go.Binding('stroke', 'color'),
            {
              name: 'SHAPE',
              cursor: 'pointer',
              portId: '',
              minSize: new go.Size(NaN, 50),
              maxSize: new go.Size(300, 150),
              width: 90,
              height: 95,
              fromSpot: go.Spot.AllSides,
              fromLinkable: true,
              fromLinkableDuplicates: false,
              fromLinkableSelfNode: false,
              toSpot: go.Spot.AllSides,
              toLinkable: true,
              toLinkableDuplicates: false,
              toLinkableSelfNode: false,
              fill: '#191a1c',
              strokeWidth: 2
            }),
          $(go.Shape,
            new go.Binding('geometry', 'category', this.getNodeShape),
            new go.Binding('fill', 'color'),
            {
              name: 'SHAPE',
              width: 40,
              height: 40,
              fill: '#191a1c',
              margin: new Margin(15, 5, 10, 5),
              alignment: go.Spot.Top
            }),
          $(go.TextBlock,
            {
              name: 'TEXTBLOCK',
              font: '15px Lato, sans-serif',
              editable: false,
              maxSize: new go.Size(150, NaN),
              overflow: go.TextBlock.OverflowEllipsis,
              maxLines: 5,
              margin: new Margin(0, 5, 10, 5),
              alignment: go.Spot.Bottom
            },
            new go.Binding('text', 'title').makeTwoWay(),
            new go.Binding('stroke', 'category', this.getNodeColor)
          ),
          // $('TreeExpanderButton',
          //   { alignment: go.Spot.RightCenter, alignmentFocus: go.Spot.Right },
          //   { visible: true }
          // ),
          {
            selectionAdornmentTemplate:
            $(go.Adornment, 'Spot',
              $(go.Panel, 'Auto',
                $(go.Shape, { stroke: 'yellow', strokeWidth: 4, fill: null }),
                $(go.Placeholder)
              ),
              $(go.Panel, 'Vertical',
                { alignment: go.Spot.Right, alignmentFocus: go.Spot.Left },
                // $('Button',
                //   { click: this.editText },  // defined below, to support editing the text of the node
                //   $(go.TextBlock, 't',
                //     { font: 'bold 10pt sans-serif', desiredSize: new go.Size(15, 15), textAlign: 'center' })
                // ),
                // $('Button',
                //   { click: changeColor, '_buttonFillOver': 'transparent' },  // defined below, to support changing the color of the node
                //   new go.Binding('ButtonBorder.fill', 'color', nextColor),
                //   $(go.Shape,
                //     { fill: null, stroke: null, desiredSize: new go.Size(14, 14) })
                // ),
                $('Button',
                  { // drawLink is defined below, to support interactively drawing new links
                    click: this.drawLink,  // click on Button and then click on target node
                    actionMove: this.drawLink  // drag from Button to the target node
                  },
                  $(go.Shape,
                    { geometryString: 'M0 0 L8 0 8 12 14 12 M12 10 L14 12 12 14' })
                )
                // $('Button',
                //   {
                //     actionMove: dragNewNode,  // defined below, to support dragging from the button
                //     _dragData: { text: 'a Node', color: 'lightgray' },  // node data to copy
                //     click: clickNewNode  // defined below, to support a click on the button
                //   },
                //   $(go.Shape,
                //     { geometryString: 'M0 0 L3 0 3 10 6 10 x F1 M6 6 L14 6 14 14 6 14z', fill: 'gray' })
                // )
              )
            )
          }
        )
    const logicTemplate =
        $(go.Node, 'Table',
          {
            mouseEnter: this.mouseEnter,
            mouseLeave: this.mouseLeave,
            contextMenu: nodeMenu,
            // resizeObjectName: 'SHAPE',
            selectionObjectName: 'SHAPE',
            // resizable: true,
            linkConnected: function (node, link, port) {
              if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks()
              if (link.toNode !== null) link.toNode.invalidateConnectedLinks()
            },
            linkDisconnected: function (node, link, port) {
              if (link.fromNode !== null) link.fromNode.invalidateConnectedLinks()
              if (link.toNode !== null) link.toNode.invalidateConnectedLinks()
            },
            locationSpot: go.Spot.Center
          },
          $(go.Shape, 'Circle',
            new go.Binding('stroke', 'color'),
            {
              name: 'SHAPE',
              fill: '#191a1c',
              cursor: 'pointer',
              portId: '',
              width: 90,
              fromSpot: go.Spot.AllSides,
              fromLinkable: true,
              fromLinkableDuplicates: true,
              fromLinkableSelfNode: true,
              toSpot: go.Spot.AllSides,
              toLinkable: true,
              toLinkableDuplicates: true,
              toLinkableSelfNode: true,
              strokeWidth: 2
            }
          ),
          $(go.Shape,
            new go.Binding('geometry', 'category', this.getNodeShape),
            new go.Binding('stroke', 'color'),
            new go.Binding('fill', 'color'),
            {
              name: 'SHAPE',
              width: 30,
              height: 30,
              margin: new Margin(20, 0, 0, 0),
              alignment: go.Spot.Top
            }),
          $(go.TextBlock,
            {
              name: 'TEXTBLOCK',
              font: '13px Lato, sans-serif',
              editable: false,
              maxSize: new go.Size(150, NaN),
              overflow: go.TextBlock.OverflowEllipsis,
              maxLines: 5,
              margin: new Margin(0, 0, 15, 0),
              alignment: go.Spot.Bottom
            },
            new go.Binding('text', 'title').makeTwoWay(),
            new go.Binding('stroke', 'category', this.getNodeColor)
          ),
          // $('TreeExpanderButton',
          //   { alignment: go.Spot.LeftCenter, alignmentFocus: go.Spot.Right },
          //   { visible: true }
          // ),
          {
            selectionAdornmentTemplate:
            $(go.Adornment, 'Spot',
              $(go.Panel, 'Auto',
                $(go.Shape, { stroke: 'yellow', strokeWidth: 4, fill: null }),
                $(go.Placeholder)

              ),
              $(go.Panel, 'Horizontal',
                { alignment: go.Spot.Top, alignmentFocus: go.Spot.Bottom },
                $('Button',
                  { // drawLink is defined below, to support interactively drawing new links
                    click: this.drawLink,  // click on Button and then click on target node
                    actionMove: this.drawLink  // drag from Button to the target node
                  },
                  $(go.Shape,
                    { geometryString: 'M0 0 L8 0 8 12 14 12 M12 10 L14 12 12 14' })
                )
              )
            )
          }
        )
    // define the 4arrows shape

    const rootTemplate =
        $(go.Node, 'Auto',
          // {
          //   locationSpot: go.Spot.Center
          // },
          $(go.Shape, 'Rectangle',
            {
              name: 'SHAPE',
              fill: '#191a1c',
              stroke: '#191a1c',
              cursor: 'pointer',
              width: 90,
              height: 90,
              portId: '',
              fromSpot: go.Spot.AllSides,
              fromLinkable: true,
              fromLinkableDuplicates: true,
              fromLinkableSelfNode: true,
              toSpot: go.Spot.AllSides,
              toLinkable: true,
              toLinkableDuplicates: true,
              toLinkableSelfNode: true
            }
          ),
          $(go.TextBlock,
            {
              name: 'TEXTBLOCK',
              font: '16px Lato, sans-serif',
              editable: false,
              stroke: 'white',
              overflow: go.TextBlock.OverflowEllipsis,
              maxLines: 5,
              margin: 3,
              alignment: go.Spot.Center
            },
            new go.Binding('text', 'title').makeTwoWay()
          ),
          $('TreeExpanderButton',
            { alignment: go.Spot.Right, alignmentFocus: go.Spot.Bottom },
            { visible: true }
          ),
          {
            selectionAdornmentTemplate:
            $(go.Adornment, 'Spot',
              $(go.Panel, 'Auto',
                $(go.Shape, { stroke: 'yellow', strokeWidth: 4, fill: null }),
                $(go.Placeholder)
              )
            )
          }
        )
        // add templates above
    myDiagram.nodeTemplateMap.add('Root', rootTemplate)
    myDiagram.nodeTemplateMap.add('Scene', nodeTemplate)
    myDiagram.nodeTemplateMap.add('User', nodeTemplate)
    myDiagram.nodeTemplateMap.add('Universal', nodeTemplate)
    myDiagram.nodeTemplateMap.add('Logic', logicTemplate)
    myDiagram.nodeTemplateMap.add('Chatbot', nodeTemplate)

    myDiagram.linkTemplate =
    $(go.Link,
      { routing: go.Link.AvoidsNodes, corner: 5 },
      // arrow color
      $(go.Shape, { strokeWidth: 2, stroke: 'white' }),
      $(go.Shape, { toArrow: 'OpenTriangle' }),
      $(go.Panel, 'Auto',
        // $(go.Shape,  // the label background, which becomes transparent around the edges
        //   {
        //     fill: $(go.Brush, 'Radial',
        //       { 0: 'rgb(255, 255, 255)', 0.3: 'rgb(255, 255, 255)', 1: 'rgba(255, 255, 255, 0)' }),
        //     stroke: null
        //   }),
        $(go.TextBlock, '',  // the label text
          {
            textAlign: 'center',
            stroke: 'white',
            font: '10pt helvetica, arial, sans-serif',
            margin: 4,
            editable: false  // enable in-place editing
          },
          // editing the text automatically updates the model data
          new go.Binding('text').makeTwoWay())
      )
    )

    myDiagram.allowZoom = false

    this.diagram = myDiagram

    this.updateModel(this.modelData)
  },
  watch: {
    modelData () {
      // let model = this.diagram.model
      this.updateModel(this.modelData)
      // this.updateDiagramFromData()
    }
    // myScale (n, o) {
    //   this.Scale = n / 100
    //   this.diagram.scale = this.Scale
    // }
  },
  methods: {
    model () {
      return this.diagram.model
    },
    updateModel (val) {
      // No GoJS transaction permitted when replacing Diagram.model.
      if (val instanceof go.Model) {
        this.diagram.model = val
      } else {
        let m = new go.GraphLinksModel()
        if (val) {
          for (let p in val) {
            m[p] = val[p]
          }
        }
        this.diagram.model = m
      }
    },
    // Edit text tool for adornment
    editText (e, button) {
      let node = button.part.adornedPart
      e.diagram.commandHandler.editTextBlock(node.findObject('TEXTBLOCK'))
    },
    drawLink (e, button) {
      let node = button.part.adornedPart
      let tool = e.diagram.toolManager.linkingTool
      tool.startObject = node.port
      e.diagram.currentTool = tool
      tool.doActivate()
    },
    getNodeColor (category) {
      return this.nodeColors[category]
    },
    getNodeShape (category) {
      let svg = this.nodeShapes[category]
      if (typeof svg === 'string') {
        svg = this.nodeShapes[category] = go.Geometry.parse(svg, true)  // fill each geometry
      }
      return svg
    },
    collapseExpand (e, obj) {
      if (e.diagram.commandHandler.canExpandTree()) {
        e.diagram.commandHandler.expandTree()
      } else if (e.diagram.commandHandler.canCollapseTree()) {
        e.diagram.commandHandler.collapseTree()
      }
    },
    updateDiagramFromData () {
      this.diagram.startTransaction()
      // This is very general but very inefficient.
      // It would be better to modify the diagramData data by calling
      // Model.setDataProperty or Model.addNodeData, et al.
      this.diagram.updateAllRelationshipsFromData()
      this.diagram.updateAllTargetBindings()
      this.diagram.commitTransaction('updated')
    },
    // hightlighten when hover
    mouseEnter (e, obj) {
      let shape = obj.findObject('SHAPE')
      // shape.fill = 'grey'
      shape.stroke = 'yellow'
      // let text = obj.findObject('TEXTBLOCK')
      // text.stroke = 'white'
    },
    mouseLeave (e, obj) {
      let shape = obj.findObject('SHAPE')
    // Return the Shape's fill and stroke to the defaults
      // shape.fill = '#121724'
      shape.stroke = this.getNodeColor(obj.data.category)
    // Return the TextBlock's stroke to its default
      // let text = obj.findObject('TEXTBLOCK')
      // text.stroke = 'black'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/story-edit-view/treeview/gojsTree.vue